export default __webpack_public_path__ + "static/media/botoes_genericos_03.5dc59fd7.mp3";